import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { resetField, fetchWorkoutPlans, addPlanToMyWorkout } from "../../../store/actions";
import Tooltip from "../../../sharedComponents/tooltip";

const AddPlanPanel = ({ showAddPlanPanel, resetField, fetchWorkoutPlans, workoutPlanList, addPlanToMyWorkout }) => {
	useEffect(() => {
		fetchWorkoutPlans();
	}, [fetchWorkoutPlans]);

	const resetReducerField = () => resetField("Exercises.toggleAddExercisePanel", false);

	const [selected, setSelected] = useState([]);

	const addToSelected = (id) => {
		const newItems = selected.indexOf(id) > -1 ? selected.filter((item) => item !== id) : [...selected, id];
		setSelected(newItems);
	};

	const addItems = () => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Successfully added!", "", 5000);
				resetReducerField();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};
		return selected && selected.length ? addPlanToMyWorkout({ plan: selected.join() }, successHandler) : null;
	};

	const cancelItems = () => {
		setSelected([]);
		resetReducerField();
	};

	return (
		<FilterPanel show={showAddPlanPanel} toggle={cancelItems} title="Add plans" className="hide-sub-header" closeBtn>
			<PanelBody>
				{workoutPlanList
					? workoutPlanList.map((item, index) => {
						return (
							<div key={index}>
								<h4 className="text-primary-dark">{item.subgroup}</h4>
								<div className="row">
									{item.data.map((card) => {
										const isSelected = selected.indexOf(card.id) > -1;
										return (
											<div className="col-6 mb-3 pb-2" key={card.id}>
												<div className="card card-light h-100 rounded border-0 p-3 align-items-start">
													<div className="d-flex justify-content-between w-100">
														<div className="workout-plan-icon">
															<i className="icon icon-workout-plan xl-icon text-primary-dark" />
														</div>
														<Tooltip content="Select Plan">
															<button
																type="button"
																className={`btn ${
																	isSelected ? "btn-primary-dark" : "btn-light"
																	} btn-cell`}
																onClick={() => addToSelected(card.id)}>
																<i className="icon icon-add-to-plan" />
															</button>
														</Tooltip>
													</div>
													<div className="pt-3">
														<h4 className="font-weight-bold">{card.name} </h4>
														<p className="text-primary mb-0">
															{card.group}{" "}
															<span className="text-primary-dark">{card.subgroup} </span>
														</p>
														<p className="m-0">{card.description}</p>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						);
					})
					: null}
			</PanelBody>
			<PanelFooter className="sticky-footer text-right">
				<button type="button" className="btn btn-default" onClick={cancelItems}>
					Cancel
				</button>
				<button type="button" className="btn btn-primary-dark" onClick={addItems} disabled={!selected.length}>
					Add items
				</button>
			</PanelFooter>
		</FilterPanel>
	);
};

const mapStateToProps = (state) => {
	const { Exercises, WorkoutPlans } = state;
	return {
		showAddPlanPanel: get(Exercises, "toggleAddExercisePanel", false),
		workoutPlanList: get(WorkoutPlans, "workoutPlanList.results", [])
	};
};

const mapDispatchToProps = {
	resetField,
	fetchWorkoutPlans,
	addPlanToMyWorkout
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddPlanPanel);
